import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ResourceVersionFragment = { id: string, versionNumber: string, note: string, type: Types.ResourceVersionTypeEnum, createdAt: string, createdBy?: { id: string, name?: string | null } | null };


export type ResourceVersionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ResourceVersionFragmentDoc = /*#__PURE__*/ gql`
    fragment ResourceVersion on ResourceVersionType {
  id
  versionNumber
  note
  type
  createdAt
  createdBy {
    id
    name
  }
}
    `;